// extracted by css-extract-rspack-plugin
export default {"root":"Ln91nl","main-thumb":"heMIPN","mainThumb":"heMIPN","separator":"CWePus","thumbs-slider":"R6rfeI","thumbsSlider":"R6rfeI"};